import { FILTER_KIND, type TSimpleFilterConfig } from '../types/filter-config';

export const createSimpleFilterConfig = (
  config: Omit<TSimpleFilterConfig, 'kind'>
): TSimpleFilterConfig => ({
  kind: FILTER_KIND.simple,
  ...config,
});
